import ICONS from "../icons";
import { team } from "../../data/siteContent";

export const Team = () => (
  <section className="section team-section" id="team" data-testid="team-section">
    <div className="section-heading" data-testid="team-heading">
      <h2 data-testid="team-title">The Brain Behind Vartalab</h2>
      <p data-testid="team-subtitle">
        A hands on founder who leads every engagement personally, across all
        three pillars.
      </p>
    </div>
    <div className="team-grid single" data-testid="team-grid">
      {team.map((member, index) => {
        const RoleIcon = ICONS[member.icon];
        return (
          <div
            className="team-card"
            key={member.name}
            data-testid={`team-card-${index}`}
          >
            <div className="team-avatar-wrap">
              <img
                className="team-avatar-photo"
                style={{ borderColor: member.accent }}
                src={member.photo}
                alt={member.name}
                data-testid={`team-card-${index}-avatar`}
              />
              <span
                className="team-role-icon"
                style={{ background: member.accent }}
                aria-hidden="true"
              >
                <RoleIcon />
              </span>
            </div>
            <h3 data-testid={`team-card-${index}-name`}>{member.name}</h3>
            <span
              className="team-role"
              style={{ color: member.accent }}
              data-testid={`team-card-${index}-role`}
            >
              {member.role}
            </span>
            <p data-testid={`team-card-${index}-bio`}>{member.bio}</p>
          </div>
        );
      })}
    </div>
  </section>
);
